import { ValueObject } from '../../../shared/models/ValueObject';

/**
 * 세션 ID 값 객체
 */
export class SessionId extends ValueObject<string> {
  private readonly _value: string;

  constructor(value: string) {
    super();
    this.validate(value);
    this._value = value;
  }

  get value(): string {
    return this._value;
  }

  private validate(value: string): void {
    if (!value) {
      throw new Error('SessionId는 비어있을 수 없습니다');
    }
    if (value.length < 32) {
      throw new Error('SessionId는 32자 이상이어야 합니다');
    }
  }

  protected equalsCore(vo: SessionId): boolean {
    return this._value === vo._value;
  }

  protected copy(): SessionId {
    return new SessionId(this._value);
  }

  toString(): string {
    return this._value;
  }

  /**
   * 새로운 SessionId 생성
   */
  static create(): SessionId {
    // 실제로는 보안이 강화된 토큰 생성 로직 사용
    const timestamp = Date.now().toString(36);
    const randomStr = Array.from({ length: 32 }, () => 
      Math.random().toString(36).charAt(2)
    ).join('');
    return new SessionId(`sess_${timestamp}_${randomStr}`);
  }

  /**
   * 기존 값으로부터 SessionId 생성
   */
  static fromString(value: string): SessionId {
    return new SessionId(value);
  }
}